module.exports = __webpack_public_path__ + "img/product19p.012ce17e.png";